

export const BASE_URL = `${process.env.REACT_APP_BASE_URL}/api/v1`;
export const SSO_API_URL = `${process.env.REACT_APP_SSO_URL}/api/sso`;
export const GOOGLE_API_BASE_URL = "https://maps.googleapis.com/maps/api";
export const CHOOSE_PLATFORM_PAGE = `${SSO_API_URL}/platforms/choose/`;

type RefId = string | number;

export const SsoApiUrl = {
  tokenVerify: `${SSO_API_URL}/jwt/token/verify/`,
  tokenRefresh: `${SSO_API_URL}/jwt/token/refresh/`,
  loginPage: `${SSO_API_URL}/users/login/`,
  logoutPage: `${SSO_API_URL}/users/logout/`,
  passwordUpdate: `${SSO_API_URL}/accounts/password_change/`,
  featureFlag: `${SSO_API_URL}/feature-flags/`,

  organization: {
    organizationInviteList: `${SSO_API_URL}/organizations/invite-list/`,
    organizationCurrent: `${SSO_API_URL}/organizations/me/`,
    organization: (ref: RefId) => `${SSO_API_URL}/organizations/${ref}/`,
    organizationRoles: `${SSO_API_URL}/organizations/roles/`,
    organizationUsers: (ref: RefId) =>
      `${SSO_API_URL}/organizations/${ref}/users/`,
    organizationUser: (ref: RefId, userRef: RefId) =>
      `${SSO_API_URL}/organizations/${ref}/users/${userRef}/`,
    organizationUserRole: (ref: RefId, userRef: RefId, roleId: RefId) =>
      `${SSO_API_URL}/organizations/${ref}/users/${userRef}/assign-role/${roleId}/`,
  },
  roles: {
    projectRoles: `${SSO_API_URL}/roles/platform-roles/`,
  },
  userManagement: {
    users: `${SSO_API_URL}/users/`,
    usersInvite: `${SSO_API_URL}/users/invite/`,
    user: (ref: RefId) => `${SSO_API_URL}/users/${ref}/`,
    userCurrent: `${SSO_API_URL}/users/me/`,
    userProjects: (ref: RefId) => `${SSO_API_URL}/users/${ref}/projects/`,
    userInvite: (ref: RefId) => `${SSO_API_URL}/users/invite/${ref}/`,
    userStatusOptions: `${SSO_API_URL}/users/status-count/`,
  },
  projectManagement: {
    project: (ref: RefId) => `${SSO_API_URL}/projects/${ref}/`,
    projectUsers: (ref: RefId) => `${SSO_API_URL}/projects/${ref}/members/`,
    projectUser: (ref: RefId, userRef: RefId) =>
      `${SSO_API_URL}/projects/${ref}/members/${userRef}/`,
    projectUsersRole: (ref: RefId, userRef: RefId, roleId: RefId) =>
      `${SSO_API_URL}/projects/${ref}/members/${userRef}/assign-role/${roleId}/`,
  },
  filterOptions: {
    projectUserStatusOptions: `${SSO_API_URL}/projects/status-count/`,
    projectUserRoleOptions: `${SSO_API_URL}/roles/platform-roles/`,
    projectOrganizationOptions: `${SSO_API_URL}/organizations/users-count/`,
  },
};

export const ApiUrl = {
  googleAPI: {
    getGeoCode: `${GOOGLE_API_BASE_URL}/geocode/json`,
    getTimeZone: `${GOOGLE_API_BASE_URL}/timezone/json`,
  },
  preferences: {
    languages: `${BASE_URL}/preferences/language/`,
    dateFormats: `${BASE_URL}/preferences/date/format/`,
    timeFormats: `${BASE_URL}/preferences/time/format/`,
    calenderDays: `${BASE_URL}/preferences/calender/days/`,
  },
  profileModule: {
    userMinimal: `${BASE_URL}/users/minimal/`,
    userPreferences: `${BASE_URL}/users/mypreference/`,
  },
  siteManagement: {
    getSiteList: `${BASE_URL}/sites/`,
    getListProject: `${BASE_URL}/projects/`,
    getListAccesspoint: `${BASE_URL}/projects/access-point/`,
    getSiteDetail: `${BASE_URL}/projects/details/`,
    getContactList: `${BASE_URL}/projects/contacts/`,
    getResourceList: `${BASE_URL}/projects/resource/`,
    getTimes: `${BASE_URL}/legacy/time/`,
    getSite: `${BASE_URL}/sites/`,
    getSiteAvailablity: `${BASE_URL}/projects/sites/availability/`,
    getBookingDetailData: `${BASE_URL}/booking-fields/`,
    getSiteVehicles: `${BASE_URL}/booking-fields/vehicle-type/`,
  },
  Availability: {
    getResourceList: `${BASE_URL}/projects/resource/`,
    getAvailability: `${BASE_URL}/availability/`,
    getTimes: `${BASE_URL}/legacy/time/`,
    addSiteBreak: `${BASE_URL}/projects/sites/`,
  },
  booking: {
    vehicleTypes: `${BASE_URL}/projects/vehicle-type/`,
    reserveSlots: `${BASE_URL}/bookings/slots/reserve/`,
    createBookingcall: `${BASE_URL}/bookings/`,
    slots: `${BASE_URL}/slots/`,
    updateSlot: (slotId: RefId) => `${BASE_URL}/slots/${slotId}/`,
    getProjectSetting: `${BASE_URL}/projects/settings/`,
    bookingList: `${BASE_URL}/bookings/`,
    bookingView: `${BASE_URL}/column-view/`,
    bookingStatusUpdate: `${BASE_URL}/bookings/`,
    uploadFlexFiles: `${BASE_URL}/booking-fields/attachments/`,
    activity: `${BASE_URL}/auditlog/booking/`,
    flexForm: `${BASE_URL}/booking-fields/forms`,
  },
  notifications: {
    defaultPreference: `${BASE_URL}/notifications/preferences/me`,
    list: `${BASE_URL}/notifications/`,
    unreadCount: `${BASE_URL}/notifications/unread-count/`,
    markAsRead: (notificationId: RefId) => `${BASE_URL}/notifications/${notificationId}/read/`,
    delete: (notificationId: RefId) => `${BASE_URL}/notifications/${notificationId}/`,
    bulkActions: `${BASE_URL}/notifications/bulk-actions/`,
    pushSubscriptions: `${BASE_URL}/notifications/push-subscription/`,
  },
  projectSettings: {
    proFeature: `${BASE_URL}/projects/pro-features/`,
    integrations: `${BASE_URL}/integrations/`,
    companies: `${BASE_URL}/integrations/procore/companies/`,
    procoreUsers: `${BASE_URL}/integrations/procore/projects/`,
    organizations: `${BASE_URL}/organizations/list-for-invite/`,
  },
  equipmentModule: {
    equipmentMaster: `${BASE_URL}/equipments/site-equipment-master/`,
    equipmentMasterData: `${BASE_URL}/equipments/site-equipment-master/list_global_equipments/`,
    equipmentMasterCopy: `${BASE_URL}/equipments/site-equipment-master/copy-from-global/`,
    equipmentMasterById: (ref: RefId) =>
      `${BASE_URL}/equipments/site-equipment-master/${ref}/`,
    equpimentTypes: `${BASE_URL}/equipments/site-equipment-master/equipment_types/`,
    equpimentCategories: `${BASE_URL}/equipments/site-equipment-master/categories/`,
    equipmentBrads: `${BASE_URL}/equipments/site-equipment-master/brands/`,
    equipmentRegistry: `${BASE_URL}/equipments/equipment-registry/`,
    getListOfEquipmentRegistry: `${BASE_URL}/equipments/equipment-registry/unique-equipment/`,
    equipmentRegistryBulkUpload: `${BASE_URL}/equipments/equipment-registry/bulk-upload/`,
    equipmentRegistryById: (ref: RefId) =>
      `${BASE_URL}/equipments/equipment-registry/${ref}/`,
    equipmentMonthlyUsage: `${BASE_URL}/equipments/monthly-usage/`,
    equipmentMonthlyUsageById: (ref: RefId) =>
      `${BASE_URL}/equipments/monthly-usage/${ref}/`,
    downloadEquipmentUsageReports: `${BASE_URL}/equipments/monthly-usage/export/`,
    uploadEquipmentUsage: `${BASE_URL}/equipments/monthly-usage/upload_equipment_usage/`,
    uploadEquipment: `${BASE_URL}/equipments/site-equipment-master/bulk_upload/`,
    equipmentUsageAttachment: (ref: RefId) =>
      `${BASE_URL}/equipments/equipment-usage/${ref}/attachments/`,
    offRoadReports: `${BASE_URL}/equipments/equipment-reports/usage_off_road_report/`,
    materialTransportReports: `${BASE_URL}/equipments/equipment-reports/material_transport_report/`,
    summaryReports: `${BASE_URL}/equipments/equipment-reports/usage_summary_report/`,
    environmentReports: `${BASE_URL}/equipments/equipment-reports/chart_and_table_data/`,
    downloadOffRoadReports: `${BASE_URL}/equipments/equipment-reports/export_report/`,
    downloadEquipmentListReports: `${BASE_URL}/equipments/equipment-registry/export/`,
    rejectEmission: `${BASE_URL}/equipments/site-equipment-master/reject-equipment-emission/`,
    approveEmission: `${BASE_URL}/equipments/site-equipment-master/approve-equipment-emission/`,
  },
  vehicleModule: {
    vehicleMaster: `${BASE_URL}/vehicles/site-vehicle-emissions/`,
    vehicleMasterData: `${BASE_URL}/vehicles/site-vehicle-emissions/list_global_vehicles/`,
    VehicleMasterCopy: `${BASE_URL}/vehicles/site-vehicle-emissions/copy-from-global/`,
    vehicleMasterById: (ref: RefId) =>
      `${BASE_URL}/vehicles/site-vehicle-emissions/${ref}/`,
    vehicleEmission: `${BASE_URL}/vehicles/site-vehicle-emissions/`,
    vehicleEmissionById: (ref: RefId) =>
      `${BASE_URL}/vehicles/site-vehicle-emissions/${ref}/`,
    uniqueVehicles: `${BASE_URL}/vehicles/site-vehicle-emissions/unique-vehicles/`,
    approveEmission: `${BASE_URL}/vehicles/site-vehicle-emissions/approve-site-emission/`,
    rejectEmission: `${BASE_URL}/vehicles/site-vehicle-emissions/reject-site-emission/`,
  },
  CountryUomModule: {
    getCountryUom: `${BASE_URL}/country-uom/`,
    postCountryUom: `${BASE_URL}/country-uom/`,
    countryList: `${BASE_URL}/country-uom/countries/`,
    updateCountryUom: (ref: RefId) => `${BASE_URL}/country-uom/${ref}/`,
    deleteCountryUom: (ref: RefId) => `${BASE_URL}/country-uom/${ref}/`,
  },
  commonUtils: {
    commonUtils: `${BASE_URL}/common-utils/common-utils/`,
    getCommonUtilsByType: (type: string) =>
      `${BASE_URL}/common-utils/common-utils/filter/?type=${type}`,
    activities: `${BASE_URL}/common-utils/activity-master/`,
    utilsTypes: `${BASE_URL}/common-utils/common-utils/list_types/`,
  },
  systemBanners: {
    activeBanners: `${BASE_URL}/system-banners/active/`,
  },
};
export const getUrl = (url1: string, url2: string, site: any) => {
    let url = url1 + site + url2;
    if (!url.endsWith("/")) {
      return url + "/";
    }
    return url
};
